module.exports = __webpack_public_path__ + "img/03.4d8c0b1c.jpg";